import {memo} from 'react';


export default function unionContexts(Component, ...args) {
  if (args.length === 0) {
    return memo(Component);
  }
  const [[FirstContext, ...firstKeys], ...contexts] = args;
  return contexts.reduce(
    (acc, [Context, ...keys]) => Context.withContext(acc, keys),
    FirstContext.withContext(
      Component,
      firstKeys,
    ),
  );
}
